import { Form, Select } from 'antd'
import { useMemo } from 'react'

import { CompletePageType } from '@/pages/Contexts/FormBuilderContext'
import FormAntd from '@/ui/form/antd/FormAntd'

import { COMPLETE_PAGE_ACTIONS } from '../ConditionCompletePage/ConditionCompletePageForm'
import { CustomCompletePageModel } from '../useCustomCompletePageForm'
import {
  DefaultCompletePageResponseFormModel,
  useDefaultCompletePageResponseForm,
} from './useDefaultCompletePageResponseForm'

type Props = {
  onDefaultResponse: (data: CustomCompletePageModel) => void
  completePage: CompletePageType
}
export const DefaultCompletePageResponseForm = ({
  onDefaultResponse,
  completePage,
}: Props) => {
  const { form, rule } = useDefaultCompletePageResponseForm()

  const initialValues = useMemo(() => {
    if (!completePage) return
    if (completePage.hasRedirectRules) {
      let type = 'custom_page'
      if (completePage.redirectUrl) {
        type = 'redirect_url'
      }
      return {
        type,
        enter_url: completePage.redirectUrl,
      }
    }
  }, [completePage])
  return (
    <div className="mb-5 mt-3 flex w-full flex-col gap-2 overflow-hidden rounded-lg border bg-white">
      <div className="bg-gray-100/90 px-2.5 py-2">
        <h2 className="w-full text-base font-medium">Default response</h2>
        <p className="mb-1 text-xs text-gray-500">
          If no conditions match, use this as fallback
        </p>
      </div>
      <FormAntd.Root<DefaultCompletePageResponseFormModel>
        className="flex w-full flex-col gap-3 px-3 pb-3 pt-2"
        form={form}
        initialValues={initialValues}
        layout="vertical"
        onValuesChange={(_, allValues) => onDefaultResponse(allValues)}
        validateTrigger={['onBlur']}
      >
        <Form.Item<DefaultCompletePageResponseFormModel>
          noStyle
          name="type"
          rules={[rule]}
        >
          <Select
            options={COMPLETE_PAGE_ACTIONS}
            placeholder="Select a default option"
          />
        </Form.Item>

        <Form.Item<DefaultCompletePageResponseFormModel>
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.type !== currentValues.type
          }
        >
          {({ getFieldValue }) => {
            const isRedirectUrl = getFieldValue('type') === 'redirect_url'
            if (!isRedirectUrl) return null
            return (
              <div className="flex flex-col gap-0.5">
                <Form.Item<DefaultCompletePageResponseFormModel>
                  name="enter_url"
                  rules={[rule]}
                >
                  <FormAntd.Input
                    allowClear
                    className="bg-white"
                    placeholder="Enter default URL with https://"
                    type="text"
                  />
                </Form.Item>

                <span className="ml-0.5 text-xs text-gray-400">
                  Default URL to redirect to if no conditions match
                </span>
              </div>
            )
          }}
        </Form.Item>
      </FormAntd.Root>
    </div>
  )
}
